const mixin = {
  data: function() {
    return {
      faqlist: {}
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    rrp: function() {
      return this.item.rrp
    },
    faqs() {
      return Object.values(this.faqlist)
    },
    relatedProducts() {
      if (Object.keys(this.item).includes('related_products') && this.item.related_products.length > 0) {
        const relatedProductIDs = this.item.related_products.reduce((acc, val) => {
          const product = val.product
          const productIsValid = product !== null

          return productIsValid
            ? acc.concat(product.id)
            : acc
        }, [])

        // getAdHocStorageValue('winecatalog') stores {id}-only references
        // (see winecatalog-preload-helper.js) - the id-based filter works
        // against sparse refs, but dereference the matches against the main
        // catalog since these get displayed (title, image, price, etc.).
        return this.$store.getters.getAdHocStorageValue('winecatalog')
          .filter(product => relatedProductIDs.includes(product.id))
          .map(product => this.$store.getters['products/findProductByID'](product.id) || product)
      }
      else {
        return []
      }
    },
    productTheme() {
      const themeSettings = this.$store.getters.getModuleSetting('theme', 'concilio-settings')
      return (themeSettings && Object.keys(themeSettings).includes('productDetailPage')) ? themeSettings.productDetailPage.theme : 'museum default-accent-1 default-type-1'
    },
    hoverCardSetting() {
      return this.retrieveConcilioLayoutSetting('hoverDisplay')
    },
    themeSettings() {
      return this.$store.state.registry.getModuleSetting('theme') || {}
    },
    concilioSettings() {
      return Object.keys(this.themeSettings).includes('concilio-settings') ? this.themeSettings['concilio-settings'] : null
    },
    themeProductSettings() {
      return Object.keys(this.themeSettings).includes('products') ? this.themeSettings.products : null
    },
    themeConcilioSettings() {
      return Object.keys(this.themeSettings).includes('concilio-settings') ? this.themeSettings.concilioSettings : null
    },
    carouselItemSettings() {
      return this.themeSettings !== null ? this.themeSettings.sliders : null
    }
  }
}

export default mixin
